export const colors = {
  white: '#FFFFFF',
  mainColor: '#040325',
  bodyTextColor: '#6C6D84',
};

export const theme = {colors};
